import React, { useEffect, useState, useRef } from 'react';

import { ClockLoader } from "react-spinners";

const CommsToAPI = ({
  message = { message }
}) => {

  return (

    <div style={{
      height: '30px',
      width: '100%',
      backgroundColor: '#29645D',
      zIndex: '1',
      position: 'absolute',
      opacity: '1',
      textAlign: 'center',
      bottom: '0px'
    }}>
      <div style={{ top: '5px', right: '675px', position: 'absolute', margin: '0px' }}>
        <p style={{ backgroundColor: 'transparent', height: 'auto', margin: '0px', display: 'inline-block', paddingRight: '15px', color: '#fff' }}>{message}</p>
        <div style={{ backgroundColor: 'transparent', height: 'auto', display: 'inline-block', top: '2px', position: 'absolute' }}>
          <ClockLoader size={15} color={'#fff'} speedMultiplier={3} />
        </div>
      </div>
    </div>

  )
};

export default CommsToAPI;
